<template>
  <div class="header-main">
     <div class="tab-main w1200">
        <div class="header-warp ">
          <img src="static/images/new_logo01.png" alt="" />
        </div>
        <ul class="tabs">
          <li class="tab-item" :class="current==1?'active':''"> <router-link :to="{name:'Index'}">首页</router-link></li>
          <li class="tab-item" :class="current==2?'active':''"><router-link :to="{name:'NewList',params: { type: 1 }}">新闻</router-link></li>
          <li class="tab-item" :class="current==3?'active':''"><router-link :to="{name:'PersonalCertificate'}">查询证书</router-link></li>
          <li class="tab-item" :class="current==4?'active':''"><router-link :to="{name:'MnaList'}">MNA</router-link></li>
          <li class="tab-item" :class="current==5?'active':''"><router-link :to="{name:'FocussList'}">焦点</router-link></li>
          <li class="tab-item" :class="current==6?'active':''"><router-link :to="{name:'AntiDopingList'}">医疗与反兴奋剂</router-link></li>
          <!-- <li class="tab-item" :class="current==4?'active':''"><router-link :to="{name:'AboutAsso'}">场馆</router-link></li>
          <li class="tab-item" :class="current==5?'active':''"><router-link :to="{name:'AboutAsso'}">赛事协会</router-link></li> -->
          <!-- <li class="tab-item" :class="current==6?'active':''"><router-link :to="{name:'AboutAsso'}">关于协会</router-link></li> -->
          <!-- <li class="tab-item" :class="current==7?'active':''"><router-link :to="{name:'AboutAsso'}">裁判考官</router-link></li> -->
          <!-- <li class="tab-item" :class="current==8?'active':''"><router-link :to="{name:'ActionMsgList',params: { type: 2 }}">活动信息</router-link></li> -->
        </ul>
      </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderNav',
  data () {
    return {
      logo: JSON.parse(localStorage.getItem('assoInfo')) ? JSON.parse(localStorage.getItem('assoInfo')).logo : 'static/images/logo.png',
      title: JSON.parse(localStorage.getItem('assoInfo')) ? JSON.parse(localStorage.getItem('assoInfo')).name : '世界跆拳道联盟'
    }
  },
  props: {
    current: {
      type: Number,
      default: 1
    },
    titleMsg: {
      type: String,
      default: '世界跆拳道联盟'
    }
  },
  methods: {
  },
  mounted () {

  },
  created () {
    document.title = this.titleMsg
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .header-main{
    width: 100%;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
    padding:10px 0px;
  }
  .header-main{
    width: 100%;
  }
  .tab-main{

    background: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .tabs{
    overflow: hidden;
  }
  .tabs .tab-item{
    width: 134px;
    text-align: center;
    color:#fff;
    font-size: 18px;
    height: 56px;
    line-height: 56px;
    float:left;
  }
  .tabs .tab-item a{
    color:#000;
  }
  .tabs .tab-item a:hover{
    text-decoration: none;
  }
  .tabs .tab-item.active {
    background: #fff;
    color:#CC0000;
  }
  .tabs .tab-item.active a{
    color:#CC0000;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/HeaderNav/HeaderNav.vue